module.exports = __webpack_public_path__ + "img/arrow-up-square-triangle.56e58826.svg";